import { render } from "./VersionEditComponent.vue?vue&type=template&id=1670b1e7&scoped=true"
import script from "./VersionEditComponent.vue?vue&type=script&lang=js"
export * from "./VersionEditComponent.vue?vue&type=script&lang=js"

import "./VersionEditComponent.vue?vue&type=style&index=0&id=1670b1e7&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/ds-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1670b1e7"]])

export default __exports__